import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";


const categories = [
  "Quem Somos",
  "Nossos Produtos",
  "Na Mídia",
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [bagCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleCategoryClick = (cat: string) => {
    if (cat === "Nossos Produtos") {
      navigate("/nossos-produtos");
    } else if (cat === "Quem Somos") {
      if (location.pathname === "/inscricao") {
        const el = document.getElementById("quem-somos");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/inscricao#quem-somos");
      }
    } else if (cat === "Na Mídia") {
      if (location.pathname === "/inscricao") {
        const el = document.getElementById("na-midia");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/inscricao#na-midia");
      }
    }
  };

  return (
    <>
      <nav
        className={`w-full z-50 transition-all duration-300 ${
          scrolled ? "fixed top-0 bg-white border-b border-gray-200 shadow-none" : "absolute top-0 bg-transparent"
        }`}
      >
        {/* Top utility bar */}
        <div className={`border-b bg-black ${scrolled ? "border-gray-700" : "border-white/20"} px-6`}>
          <div className="flex items-center justify-between py-3">
            {/* Left icons */}
            <div className="flex items-center gap-5">
              <button
                className="text-xs tracking-widest uppercase cursor-pointer flex items-center gap-1 text-white hover:opacity-70 transition"
                onClick={() => setSearchOpen(!searchOpen)}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-base"></i>
                </span>
                <span className="hidden md:inline">Buscar</span>
              </button>
            </div>

            {/* Logo */}
            <a href="/" className="select-none flex items-center justify-center">
              <img
                src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/5fa4c6c2-ce0c-44ea-b18a-4a3f7c5fa9b8_compressed_Clientizah-2026_Branca.webp"
                alt="Logo"
                className="h-40 w-auto object-contain"
              />
            </a>

            {/* Right icons */}
            <div className="flex items-center gap-5">
              <button
                onClick={() => navigate("/nossos-produtos")}
                className="relative text-xs tracking-widest uppercase cursor-pointer flex items-center gap-1 text-white hover:opacity-70 transition"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-bag-line text-base"></i>
                </span>
                <span className="hidden md:inline">Compras</span>
                {bagCount > 0 && (
                  <span className="absolute -top-1 -right-2 bg-black text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-bold">
                    {bagCount}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Category nav */}
        <div className={`${scrolled ? "border-b border-gray-200" : ""} px-6`}>
          <ul className="flex items-center justify-center gap-0">
            {categories.map((cat) => (
              <li key={cat} className="relative">
                <button
                  onMouseEnter={() => setActiveCategory(cat)}
                  onMouseLeave={() => setActiveCategory(null)}
                  onClick={() => handleCategoryClick(cat)}
                  className={`whitespace-nowrap px-4 py-3 text-xs tracking-widest uppercase font-medium cursor-pointer transition-all ${
                    scrolled ? "text-black hover:border-b-2 hover:border-black" : "text-white hover:border-b-2 hover:border-white"
                  } ${activeCategory === cat ? (scrolled ? "border-b-2 border-black" : "border-b-2 border-white") : ""}`}
                >
                  {cat}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Search bar */}
        {searchOpen && (
          <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center gap-3">
            <i className="ri-search-line text-gray-400 text-lg"></i>
            <input
              autoFocus
              type="text"
              placeholder="Search for designers, products and more..."
              className="flex-1 outline-none text-sm text-gray-800 placeholder-gray-400 tracking-wide"
            />
            <button onClick={() => setSearchOpen(false)} className="text-gray-400 hover:text-black cursor-pointer">
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
        )}
      </nav>
    </>
  );
}
